/* eslint-disable max-len */
import React, { useState } from 'react';
import NavigationLayout from '../../components/NavigationLayout';
import TeamManagementTab from './teamManagement';
import GlobalTeamSettingsTab from './globalTeamSettings';
import TeamVisibilityControlsTab from './teamVisibilityControls';
import ProductivityEmailSettingsTab from './productivityEmailSettings';

const TABS = [
  'Team Management',
  'Global Team Settings',
  'Team Visibility Controls',
  'Productivity Email Settings',
];

function TeamSettings() {
  const [value, setValue] = useState(0);

  const renderPanel = () => {
    switch (value) {
      case 0: return <TeamManagementTab />;
      case 1: return <GlobalTeamSettingsTab />;
      case 2: return <TeamVisibilityControlsTab />;
      case 3: return <ProductivityEmailSettingsTab />;
      default: return null;
    }
  };

  return (
    <div>
      <NavigationLayout title="Team Management">
        <div style={{ marginTop: 16, fontFamily: 'Inter, sans-serif' }}>
          {/* DS card with tab bar — matches Settings & Permissions */}
          <div className="bg-white border border-rule rounded-[12px] overflow-hidden" style={{ borderStyle: 'solid', boxShadow: '0 1px 2px rgba(14, 30, 64, 0.04)' }}>
            <div className="flex items-center gap-1 px-3 overflow-x-auto border-b border-rule" style={{ borderBottomStyle: 'solid' }}>
              {TABS.map((label, i) => {
                const active = value === i;
                return (
                  <button
                    key={label}
                    type="button"
                    onClick={() => setValue(i)}
                    className={`relative inline-flex items-center px-4 py-3 text-sm bg-transparent border-0 cursor-pointer whitespace-nowrap transition ${active ? 'text-ink-900 font-semibold' : 'text-ink-500 font-medium hover:text-ink-900'}`}
                  >
                    {label}
                    {active && <span className="absolute left-2 right-2 bottom-0" style={{ height: 2, background: '#213d69', borderRadius: 2 }} />}
                  </button>
                );
              })}
            </div>
            <div>
              {renderPanel()}
            </div>
          </div>
        </div>
      </NavigationLayout>
    </div>
  );
}

export default TeamSettings;
